module.exports = __webpack_public_path__ + "img/long-dark-monochrome-outline.a272fd4.svg";